import "./src/styles/global.css";
import "aos/dist/aos.css";
import AOS from "aos";
// import { AuthProvider } from "./src/context/AuthContext";

export const onInitialClientRender = () => {
  AOS.init({
    offset: -100,
    duration: 1000, // Set animation duration in ms
    once: false, // Enable repeat animations on scroll
    mirror: true,
  });
};

// export const wrapRootElement = ({ element }) => (
//   <AuthProvider>{element}</AuthProvider>
// );
